import "@/App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { NotificationProvider } from "@/contexts/NotificationContext";
import { GeofenceProvider } from "@/components/PushNotifications";
import WhatsAppBubble, { WhatsAppBubbleContext } from "@/components/WhatsAppBubble";
import HomePage from "@/pages/HomePage";
import BookingPage from "@/pages/BookingPage";
import BookingSuccessPage from "@/pages/BookingSuccessPage";
import TermsPage from "@/pages/TermsPage";
import ShoreExcursionsPage from "@/pages/ShoreExcursionsPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import DriversPage from "@/pages/DriversPage";
import ClientsPage from "@/pages/ClientsPage";
import TariffsPage from "@/pages/TariffsPage";
import TrackingPage from "@/pages/TrackingPage";
import DriverTrackingPage from "@/pages/DriverTrackingPage";
// Client pages
import ClientLoginPage from "@/pages/ClientLoginPage";
import ClientRegisterPage from "@/pages/ClientRegisterPage";
import ClientForgotPasswordPage from "@/pages/ClientForgotPasswordPage";
import ClientResetPasswordPage from "@/pages/ClientResetPasswordPage";
import ClientDashboardPage from "@/pages/ClientDashboardPage";
import ClientBookingDetailPage from "@/pages/ClientBookingDetailPage";
import AdminConfigPage from "@/pages/AdminConfigPage";

import { API_URL } from "@/config/api";

// Generate or retrieve visitor ID (privacy-compliant, no personal data)
const getVisitorId = () => {
  let visitorId = localStorage.getItem("ygo_visitor_id");
  if (!visitorId) {
    visitorId = "v_" + Math.random().toString(36).substring(2, 15) + Date.now().toString(36);
    localStorage.setItem("ygo_visitor_id", visitorId);
  }
  return visitorId;
};

// Track page visits
const trackVisit = async (page) => {
  try {
    const visitorId = getVisitorId();
    await fetch(`${API_URL}/api/track-visit`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ visitor_id: visitorId, page })
    });
  } catch (error) {
    // Silent fail - analytics should not impact user experience
  }
};

// Component to track route changes
function RouteTracker() {
  const location = useLocation();
  
  useEffect(() => {
    trackVisit(location.pathname);
  }, [location.pathname]);
  
  return null;
}

function App() {
  const [hideWhatsAppBubble, setHideWhatsAppBubble] = useState(false);
  
  return (
    <NotificationProvider>
      <GeofenceProvider>
        <WhatsAppBubbleContext.Provider value={{ hideWhatsAppBubble, setHideWhatsAppBubble }}>
          <div className="App min-h-screen bg-background">
            <BrowserRouter>
              <RouteTracker />
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/booking" element={<BookingPage />} />
                <Route path="/booking/success" element={<BookingSuccessPage />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="/excursions" element={<ShoreExcursionsPage />} />
                <Route path="/admin" element={<AdminLoginPage />} />
                <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
                <Route path="/admin/drivers" element={<DriversPage />} />
                <Route path="/admin/clients" element={<ClientsPage />} />
                <Route path="/admin/tariffs" element={<TariffsPage />} />
                <Route path="/admin/config" element={<AdminConfigPage />} />
                <Route path="/track/:token" element={<TrackingPage />} />
                <Route path="/driver/:token" element={<DriverTrackingPage />} />
                {/* Client area */}
                <Route path="/client/login" element={<ClientLoginPage />} />
                <Route path="/client/register" element={<ClientRegisterPage />} />
                <Route path="/client/forgot-password" element={<ClientForgotPasswordPage />} />
                <Route path="/client/reset-password/:token" element={<ClientResetPasswordPage />} />
                <Route path="/client/dashboard" element={<ClientDashboardPage />} />
                <Route path="/client/booking/:bookingId" element={<ClientBookingDetailPage />} />
              </Routes>
              <WhatsAppBubble />
            </BrowserRouter>
            <Toaster position="top-center" richColors />
          </div>
        </WhatsAppBubbleContext.Provider>
      </GeofenceProvider>
    </NotificationProvider>
  );
}

export default App;
